import React from "react";
import { AuthButton } from "../AuthButton";
import { formatReq, formatRes } from "./format.js";
import copy from "../../utils/copy";
import { getRule } from "./rule.js";
import request from "../../utils/request";
import DateTimePicker from "../DateTimePicker";
import * as TUI from "../../index";
import Modal from "../Modal"
import moment from "moment";
import { serialRun } from "../../utils";
const Button = AuthButton();
const LIST_MODE = "list";
const FORM_MODE = "form";
const FILTER_MODE = "filter";
const DETAIL_MODE = "detail";
const _components = {
  DateTimePicker: DateTimePicker,
};
export const getComponent = (name) => {
  return _components[name];
};
export const addComponent = (name, com) => {
  _components[name] = com;
};
export const getDefaultFields = (schema, record = {}) => {
  return schema
    .map((s) =>
      (typeof s.visible === "function" ? !s.visible({fields: record}) : s.visible === false) || !("defaultValue" in s)
        ? null
        : {
            [s.field]: s.defaultValue,
          }
    )
    .reduce((p, c) => Object.assign(p, c), {});
};
export const getOptions = (params, schema, event) => {
  const shs = schema.filter(
    (d) =>
      d.optionApi &&
      Array.isArray(d.optionTrigger) &&
      d.optionTrigger.includes(event)
  );
  return serialRun(
    shs.map((sh) => {
      //undefined不触发请求
      if (/onChange\:/.test(event)){
        let key = event.replace("onChange:", "");
        let value = params[key];
        if (value === undefined) {
          return Promise.resolve({
            [sh.field]: []
          })
        }
      }
      return request(sh.optionApi, formatReq(params, schema)).then((res) => ({
        [sh.field]: res.data,
      }));
    })
  ).then((res) => res.reduce((p, c) => Object.assign(p, c), {}));
};
export const getRelatedOptionField = (schema) => {
  const res = schema
    .filter((d) => Array.isArray(d.optionTrigger))
    .map((d) =>
      d.optionTrigger
        .filter((x) => /^onChange\:/.test(x))
        .map((m) => m.replace("onChange:", ""))
    )
    .reduce((p, c) => p.concat(c), []);
  return Array.from(new Set(res));
};
export const getComputedField = (schema) => {
  const res = schema
    .filter((d) => Array.isArray(d.computeTrigger))
    .map((d) =>
      d.computeTrigger
        .filter((x) => /^onChange\:/.test(x))
        .map((m) => m.replace("onChange:", ""))
    )
    .reduce((p, c) => p.concat(c), []);
  return Array.from(new Set(res));
};
export const getComputed = (params, schema, event, options) => {
  const shs = schema.filter(
    (d) =>
      d.computeApi &&
      Array.isArray(d.computeTrigger) &&
      d.computeTrigger.includes(event)
  );
  let cachedReq = {}
  return serialRun(
    shs.map((sh) => {
      if (!cachedReq[sh.computeApi]){
        cachedReq[sh.computeApi] = request(sh.computeApi, formatReq(params, schema), options);
      }
      return cachedReq[sh.computeApi].then(
        (res) => ({
          [sh.field]: typeof res.data === "object" ? res.data[sh.field] : res.data,
        })
      );
    })
  ).then((res) => res.reduce((p, c) => Object.assign(p, c), {}));
};
export const getFiltedSchema = (params, schema, event) => {
  const sh = schema.find(
    (d) =>
      d.schemaApi &&
      Array.isArray(d.schemaTrigger) &&
      d.schemaTrigger.includes(event)
  );
  if (!sh) return Promise.resolve(schema);
  return request(sh.schemaApi, formatReq(params, schema), copy(schema), event);
};
export const getRelatedSchemaTrigger = (schema) => {
  const res = schema
    .filter((d) => Array.isArray(d.schemaTrigger))
    .map((d) =>
      d.schemaTrigger
        .filter((x) => /^onChange\:/.test(x))
        .map((m) => m.replace("onChange:", ""))
    )
    .reduce((p, c) => p.concat(c), []);
  return Array.from(new Set(res));
};
export const getFormSchema = (schema, options, readonly = false) => {
  let form = [...schema]
    .sort((a, b) => a.formOrder - (b.formOrder || 99999))
    .reduce((p, c) => {
      if (
        c.view.includes(FORM_MODE) ||
        (readonly && c.view.includes(DETAIL_MODE))
      ) {
        p[c.field] = {
          type: TUI[c.formType] || TUI[c.type] || getComponent(c.type),
          name: c.name,
          inline: !!c.inline,
          visible: "visible" in c ? typeof c.visible === "function" ? c.visible : () => !!c.visible : undefined,
          rules: (c.rules || [])
            .filter((r) => (readonly && r === "required" ? false : true))
            .map((r) => {
              if (r === "required")
                return {
                  required: true,
                };
              return {
                validator: (v) => (v === undefined ? true : getRule(r)(v)),
              };
            }),
          opts: {
            ...c.opts,
            disabled: c.opts && "disabled" in c.opts ? !!c.opts.disabled : !!readonly,//TODO 所有组件区分开disabled 和 readonly
            readonly: !!readonly,
          },
          options: options[c.field],
          placeholder: c.placeholder,
        };
      }
      return p;
    }, {});
  return form;
};
export const getFilterSchema = (schema, options) => {
  let form = [...schema]
    .sort((a, b) => a.filterOrder - (b.filterOrder || 99999))
    .reduce((p, c) => {
      if (c.view.includes(FILTER_MODE)) {
        p[c.field] = {
          type: TUI[c.filterType] || TUI[c.type] || getComponent(c.type),
          name: c.name,
          rules: [],
          opts: c.opts,
          options: options[c.field],
          placeholder: c.placeholder,
        };
      }
      return p;
    }, {});
  return form;
};
const getColumnGroup = (columnSchema) => {
    let group = {};
    let schema = {};
    let index = 1;
    let transform = (lef, col) => {
      return ({
        ...lef,
        title: lef.name,
        dataIndex: col,
        key: col,
      })
    }
    //TODO schema优化成数组
    for (let col in columnSchema) {
      let g = columnSchema[col].group;
      if (g) {
        if (group[g]) {
          let {node} = group[g];
          node.children = node.children || [];
          node.children.push(transform(columnSchema[col], col))
        } else {
          let lef = columnSchema[col];
          let node = {
            name: g,
            children: [
              transform(lef, col)
            ]
          }
          group[g] = { field: col, node: node};
          schema["$$group" + index] = node;
          index++;
        }
      }else{
        schema[col] = columnSchema[col]
      }

    }
   return schema;
}
const getActionFromApiConfig = (api, record) => {
  let actions = []
  Object.keys(api)
    .map((key) => {
      const obj = api[key];
      const fn = obj.action;//在对象，函数里加action属性
      if (typeof fn === "function") {
        const act = fn(record);
        if (act){
          actions.push(key)
        }
      }
    })
  return actions;
}
const getDefaultColumnRender = (schema, options) => {
  const { type, optionApi, field, group, listRender } = schema;
  let render = null;
  if (listRender) return listRender;
  switch (type) {
    case "Uploader":
    case "DrawableUploader":
      render = ({ value }) => {
        //TODO 文档图标
        return <img src={value} width={48} height={48} />;
      };
      break;
    case "Editor":
    case "Textarea":
      render = ({ value }) => {
        let str = (value || "").replace(/\<\/?.*?\>/g, "");
        let max = 25;
        return str.length > max ? str.substr(0, max) + "..." : str;
      };
      break;
    case "RangePicker":
      render = ({ value }) => {
        const [s, e] = Array.isArray(value) ? value : [];
        return [
          moment(s).isValid() ? moment(s).format("YYYY-MM-DD") : "",
          moment(s).isValid() ? moment(e).format("YYYY-MM-DD") : "",
        ].filter(d => !!d).join("~");
      };
      break;
    default: 
      if (optionApi){
        render = (props) => {
          let value = group ? props : props.value;//TODO 统一render参数
          let ops = options ? options[field] : [];
          let n = (ops || []).find((d) => d.id === value);
          if (n) return n.name;
          return value;
        }
      }

  }
  return render;
};
export const getListSchema = (
  schema,
  api,
  auth,
  setFormSchema,
  options,
  filterOptions,
  showColumnAction
) => {
  let columns = schema.reduce((p, c) => {
    if (c.view.includes(LIST_MODE)) {
      p[c.field] = {
        group: c.group,
        name: c.name,
        render: getDefaultColumnRender(c, filterOptions),
        fixed: c.fixed
      };
    }
    return p;
  }, {});
  columns = getColumnGroup(columns);
  showColumnAction && (columns.id = {
    name: "操作",
    fixed: "right",
    render: (params) => {
      const { form, modal, record, setFormMode, query } = params;
      let actions = null;
      Object.keys(record).map((key) => {
        const value = record[key];
        let opt = filterOptions[key];
        if (!opt) return;
        let p = opt.find((d) => d.id === value);
        if (!p || !p.action) return;
        if (!actions) {
          actions = [...p.action];
        } else {
          actions = p.action.reduce(
            (p, c) => (actions.includes(c) ? [...p, c] : p),
            []
          );
        }
      });
      //TODO 保证现有平台正常运行的前提下，删除基于hookRequest的action配置
      actions = actions || getActionFromApiConfig(api, record) || [];
      const getDefaultActionName = act => {
        if (act === "edit") return "编辑"
        if (act === "detail") return "查看详情"
        return act;
      }
      const renderBtn = (act, mode = "edit", readonly = false, reorganizeSchema = a => a) => {
        let name = getDefaultActionName(act)
        return (
          <Button
            type="link"
            active={actions.includes(act)}
            auth={act in auth ? auth[act] : -9999}
            onClick={() => {
              let fn = (red) => {
                let formSchema = getFormSchema(reorganizeSchema(schema), options, readonly);
                setFormSchema(formSchema);
                form.setFields(formatRes(red, schema));
                setFormMode(mode);
                modal.show();
              };
              if (typeof api.detail === "string" || (typeof api.detail === "object" && api.detail.url)) {
                query(typeof api.detail === "object" ? api.detail.url : api.detail, record).then((res) => {
                  fn({
                    ...record,
                    ...res.data,
                  });
                });
              } else {
                fn(record);
              }
            }}
          >
            { typeof api[act] === "object" ? api[act].name || name : name }
          </Button>
        )
      } 
      return (
        <>
          {renderBtn("detail", "detail", true)}
          {renderBtn("edit", "edit", false)}
          {Object.keys(api)
            .filter(key => !["detail", "edit", "remove"].includes(key))
            .map((key) => {
              const fn = api[key];
              if (typeof fn === "function") {
                const Com = fn(params, setFormSchema);
                return Com;
              }
              if (typeof fn === "object") {
                let { url, name, confirm, onClick, mode, readonly, reorganizeSchema} = fn;
                //TODO 引入route组件，根据路由跳转
                if (typeof onClick === "function"){
                  return (
                    <Button 
                      type="link" 
                      active={actions.includes(key)}
                      auth={auth[key]}
                      onClick={() => onClick(record, params)}>
                      {name}
                    </Button>
                  )
                }
                if (mode){
                  return renderBtn(key, mode, !!readonly, reorganizeSchema)
                }
                return (
                  <Button
                    type="link"
                    active={actions.includes(key)}
                    auth={auth[key]}
                    onClick={() => {
                      const run = (qs = {}) => {
                        return query(url, { id: record.id, ...qs })
                          .then(() => {
                            const { list } = params;
                            list.doFetch(
                              list.query,
                              list.pagination,
                              list.filters,
                              list.sorters
                            );
                          })
                          .catch();
                      };
                      confirm = confirm
                        ? confirm
                        : key === "publish"
                        ? "是否发布？"
                        : key === "verify"
                        ? "请选择审核意见！"
                        : key === "end"
                        ? "是否结束？"
                        : "";
                      if (confirm) {
                        if (key === "verify" && confirm !== "object") {
                          confirm = {
                            content: confirm,
                            okText: "通过",
                            cancelText: "不通过",
                            field: "isPass",
                          };
                        }
                        if (typeof confirm === "object") {
                          Modal.confirm({
                            title: "提示",
                            content: eval("`" + confirm.content + "`"),
                            okText: confirm.okText || "确定",
                            cancelText: confirm.cancelText || "取消",
                            maskClosable: true,
                            onOk() {
                              run({
                                [confirm.field]: 1,
                              });
                            },
                            onCancel(e) {
                              if (e.triggerCancel) {
                                return;
                              } else {
                                run({
                                  [confirm.field]: 0,
                                })
                                  .then(() => {
                                    e();
                                  })
                                  .catch();
                              }
                            },
                          });
                        } else {
                          Modal.confirm({
                            title: "提示",
                            content: eval("`" + confirm + "`"),
                            okText: "确定",
                            cancelText: "取消",
                            maskClosable: true,
                            onOk() {
                              run();
                            },
                            onCancel() {},
                          });
                        }
                      } else {
                        run();
                      }
                    }}
                  >
                    {name}
                  </Button>
                );
              }
            })}
          <Button
            type="link"
            active={actions.includes("remove")}
            auth={api.remove ? auth.remove : -9999}
            onClick={() => {
              params.list.handleItemById(params.record);
            }}
          >
            删除
          </Button>
        </>
      );
    },
  });
  return columns;
};
//设置默认选项
export const useFirstOption = (
  {
    form,
    options,
    schema,
  }
) => {
  const { fields } = form;
  let res = fields;
  let toucehd = 0;
  for(let field in options){
    let sch = schema.find(d => d.field === field && (d.view.includes("form") || d.view.includes("detail")));
    let value = fields[field];
    if (value) continue;
    if (sch && sch.useFirstOption){
      let opts = options[field] || [];
      let [first] = opts;
      if (!first) continue;
      res[field] = sch.opts && sch.opts.labelInValue ?  first : first.id;
      toucehd++;
    }
  }
  // toucehd && form.setFields(res)
}
//清除联动字段
export const removeValueOnOptionChanged = ({
  form,
  options,
}) => {
  for (let k in options) {
    let v = options[k];
    let t = form.fields[k];
    if (Array.isArray(t)){
      let x = t.map(p => typeof p === "object" ? p.id : p);
      let m = v.map(p => p.id).reduce((p, c) => x.includes(c) ? p.concat(c) : p, [])
      if (!m.length) {
        delete form.fields[k];
      }else{
        //删除不匹配的项
        form.fields[k] = t.filter(p => m.includes(typeof p === "object" ? p.id : p))
      }
    }else{
      let m = v.find((d) => typeof t === "object" ? d.id === t.key  || d.id === t.id : d.id === t);
      if (!m) {
        delete form.fields[k];
      }
    }
  }
  //TODO 是否需要强刷
  // form.setFields(form.fields);
}